<template>
  <SfButton
    :id="`${id}-button`"
    :data-testid="`${id}-button`"
    class="!rounded-full"
    :class="[
      {
        '!bg-primary-500 hover:!bg-primary-800 focus:!bg-primary-900 disabled:!bg-disabled-300':
          variant === 'primary' && type === 'default',
      },
      {
        '!bg-neutral-900 hover:!bg-neutral-800 focus:!bg-neutral-700 disabled:!bg-disabled-300':
          variant === 'primary' && type === 'neutral',
      },
      {
        'border border-primary-700 !bg-white !text-primary-700 hover:border-primary-800 hover:!bg-primary-100 hover:!text-primary-800 focus:border-primary-900 focus:!bg-primary-200 focus:!text-primary-900 disabled:border-disabled-300 disabled:!bg-white disabled:!text-disabled-500':
          variant === 'secondary' && type === 'default',
      },
      {
        'border border-neutral-100 !bg-white !text-neutral-700 hover:border-neutral-800 hover:!bg-neutral-100 hover:!text-neutral-800 focus:border-neutral-900 focus:!bg-neutral-200 focus:!text-neutral-900 disabled:border-disabled-300 disabled:!bg-white disabled:!text-disabled-500':
          variant === 'secondary' && type === 'neutral',
      },
      {
        'border !bg-white !text-primary-700 hover:!bg-primary-100 hover:!text-primary-800 focus:!bg-primary-200 focus:!text-primary-900 disabled:!bg-white disabled:!text-disabled-500':
          variant === 'tertiary' && type === 'default',
      },
      {
        'border !bg-white !text-neutral-500 hover:!bg-disabled-200 hover:!text-neutral-600 focus:!bg-disabled-300 focus:!text-neutral-700 disabled:!bg-white disabled:!text-disabled-500':
          variant === 'tertiary' && type === 'neutral',
      },
      {
        '!bg-primary-700 hover:!bg-primary-800 focus:!bg-primary-900 disabled:!bg-primary-700 disabled:!text-white/50':
          variant === 'tertiary' && type === 'reverse',
      },
      {
        '!rounded-md !bg-primary-500 !shadow-none hover:!bg-primary-800 focus:!bg-primary-900 disabled:!bg-disabled-300':
          variant === 'navigation' && type === 'default',
      },
      {
        '!rounded-md !bg-transparent !text-primary-800 !shadow-none hover:!bg-primary-100 hover:!text-primary-900 focus:!bg-primary-200 focus:!text-primary-900 disabled:!text-disabled-500':
          variant === 'navigation' && type === 'neutral',
      },
      {
        '!bg-transparent !p-0 font-normal !text-neutral-900 !shadow-none': variant === 'none',
      },
    ]"
    :disabled="disabled || loading"
  >
    <UiLoader v-if="loading" size="sm" />
    <template v-else>
      <slot v-if="iconSide === 'right'" />
      <component
        :is="icon"
        v-if="icon"
        class="size-6"
        :class="[
          { '!fill-disabled-500': disabled },
          { 'fill-white': variant === 'primary' },
          {
            'fill-primary-700 hover:fill-primary-800 focus:fill-primary-900':
              variant === 'secondary' && type === 'default',
          },
          {
            'fill-neutral-700 hover:fill-neutral-800 focus:fill-neutral-900':
              variant === 'secondary' && type === 'neutral',
          },
          {
            'fill-primary-700 hover:fill-primary-800 focus:fill-primary-900':
              variant === 'tertiary' && type === 'default',
          },
          {
            'fill-neutral-500 hover:fill-neutral-600 focus:fill-neutral-700':
              variant === 'tertiary' && type === 'neutral',
          },
          {
            'fill-white disabled:!fill-white/50': variant === 'tertiary' && type === 'reverse',
          },
          {
            'fill-white hover:fill-neutral-100 focus:fill-neutral-200': variant === 'navigation' && type === 'default',
          },
          {
            'fill-primary-800 hover:fill-primary-900 focus:fill-primary-900':
              variant === 'navigation' && type === 'neutral',
          },
          iconClass,
        ]"
      />
      <slot v-if="iconSide === 'left'" />
    </template>
  </SfButton>
</template>

<script setup lang="ts">
import type { ButtonProps } from '~/components/ui/Button/types';

withDefaults(defineProps<ButtonProps>(), {
  iconSide: 'left',
  type: 'default',
  variant: 'primary',
});
</script>
